import { takeLatest, put, all, call } from 'redux-saga/effects';

import LedgerReportsActionTypes from './LedgerReports.types';

import { LedgerReportsListGet, AccountHeadGet } from './LedgerReports.services';

import {
	getLedgerReportsDetailsSuccess,
	getLedgerReportsDetailsFailure,
	getLedgerReportsDetailsResponseChanged,
	getAccountHeadSuccess,
	getAccountHeadFailure,
	getAccountHeadResponseChanged,
} from './LedgerReports.action';

import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START GET LEDGER REPORTS REPORT DETAILS  ******************** */
export function* getLedgerReportsList({ payload }: any) {
	try {
		const {
			DatabaseName,
			Infog_CompanyID,
			FromDate,
			ToDate,
			CompanyID,
			UserID,
			CreatedFor,
			ReportType,
			AccountHeadID,
			BranchID,
			FilterHOTrxn,
			Type,
			SearchType,
			TillDate,
		} = payload;
		const key = 'GetLedgerReportsKey';
		const jsonData = {
			DatabaseName: DatabaseName,
			Infog_CompanyID: Infog_CompanyID,
			FromDate: FromDate,
			ToDate: ToDate,
			CompanyID: CompanyID,
			UserID: UserID,
			UserRole: CreatedFor,
			SearchByViewType: ReportType,
			AccountHeadID: AccountHeadID,
			CreatedFor: BranchID,
			FilterHOTrxn: FilterHOTrxn,
			Type: Type,
			SearchType: SearchType,
			TillDate: TillDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(LedgerReportsListGet, encodeData, payload.ViewType);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLedgerReportsDetailsFailure(responseData.data));
		} else {
			yield put(getLedgerReportsDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLedgerReportsDetailsFailure(error));
	}
}

export function* resetGetLedgerReportsListResponse() {
	yield put(getLedgerReportsDetailsResponseChanged());
}

export function* onGetLedgerReportsListDetails() {
	yield takeLatest(LedgerReportsActionTypes.GET_LEDGER_REPORTS_LIST_START, getLedgerReportsList);
}

export function* onGetLedgerReportsListResponseReset() {
	yield takeLatest(
		LedgerReportsActionTypes.GET_LEDGER_REPORTS_LIST_RESPONSE_RESET,
		resetGetLedgerReportsListResponse,
	);
}
/** *********************  END GET LEDGER REPORTS REPORT LIST ******************** */

/** *********************  START GET ACCOUNT HEAD DETAILS  ******************** */
export function* getAccountHeadList({ payload }: any) {
	try {
		const { infogCompanyID, userID, databaseName } = payload;
		const key = 'GetAccountHeadKey';
		const jsonData = {
			InfogID: infogCompanyID,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(AccountHeadGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAccountHeadFailure(responseData.data));
		} else {
			yield put(getAccountHeadSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAccountHeadFailure(error));
	}
}

export function* resetGetAccountHeadListResponse() {
	yield put(getAccountHeadResponseChanged());
}

export function* onGetAccountHeadListDetails() {
	yield takeLatest(LedgerReportsActionTypes.GET_ACCOUNT_HEAD_START, getAccountHeadList);
}

export function* onGetAccountHeadListResponseReset() {
	yield takeLatest(
		LedgerReportsActionTypes.GET_ACCOUNT_HEAD_RESPONSE_RESET,
		resetGetAccountHeadListResponse,
	);
}
/** *********************  END GET ACCOUNT HEAD DETAILS ******************** */

export function* ledgerReportsSaga() {
	yield all([
		call(onGetLedgerReportsListDetails),
		call(onGetLedgerReportsListResponseReset),
		call(onGetAccountHeadListDetails),
		call(onGetAccountHeadListResponseReset),
	]);
}
